// The chat route can mount before BottomNavigation on a native cold start.
// Remember its latest slot event so a later-mounted navigation can render the
// composer without waiting for the chat to emit another open event.
let slot = { visible: false, props: null, pathname: "" };
let listening = false;

function currentPathname() {
  return typeof window === "undefined" ? "" : window.location.pathname;
}

function ensureListening() {
  if (listening || typeof window === "undefined") return;
  listening = true;

  window.addEventListener("vg-chat-input-open", (event) => {
    slot = {
      visible: true,
      props: event?.detail?.props || null,
      pathname: currentPathname(),
    };
  });
  window.addEventListener("vg-chat-input-update", (event) => {
    if (!slot.visible || slot.pathname !== currentPathname()) return;
    slot = { ...slot, props: event?.detail?.props || null };
  });
  window.addEventListener("vg-chat-input-close", () => {
    slot = { visible: false, props: null, pathname: "" };
  });
}

export function getChatInputSlotSnapshot(pathname) {
  ensureListening();
  if (slot.visible && slot.pathname === pathname) {
    return { visible: true, props: slot.props };
  }
  return { visible: false, props: null };
}

export function clearChatInputSlotSnapshot() {
  slot = { visible: false, props: null, pathname: "" };
}

ensureListening();
